export default __webpack_public_path__ + "static/media/logo.362122df.png";